export default __webpack_public_path__ + "media/join-game3x.ee52849a.png";